import React, { FC, useCallback, useLayoutEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import {
  selectCurrentVariantCohort,
  selectFeelNervousAnswer,
} from 'root-redux/selects/common'
import { Container } from 'components/Container'
import { Button } from 'components/Button'
import { triggerClickOnCanvas } from 'helpers/triggerClickOnCanvas'
import { TPageProps } from 'models/common.model'
import { OptionValue } from 'root-constants'
import { useNextStep } from 'hooks/useNextStep'
import { StyledFeelNervousDetailed as S } from './FeelNervousDetailed.styles'
import { replaceHistory } from '../../../browserHistory'
import { QUESTION } from './constants'

export const FeelNervousDetailed: FC<TPageProps> = ({
  pageId,
  nextPagePath,
}) => {
  const { t } = useTranslation()
  const feelNervousAnswer = useSelector(selectFeelNervousAnswer)
  const cohort = useSelector(selectCurrentVariantCohort)

  useLayoutEffect(() => {
    if (feelNervousAnswer === OptionValue.NOT_AT_ALL) {
      replaceHistory(nextPagePath)
    }
  }, [feelNervousAnswer, nextPagePath])

  const handleContinue = useNextStep({
    pageId,
    question: QUESTION,
    nextPagePath,
  })

  const handleNextClick = useCallback(
    (event) => {
      triggerClickOnCanvas(event)
      handleContinue('')
    },
    [handleContinue],
  )

  return (
    <Container>
      <S.Title>{t(`onboarding.feel_nervous.${cohort}.title` as any)}</S.Title>
      <S.SelectedOption>
        <span>{t(`onboarding.answers.${feelNervousAnswer}` as any)}</span>
      </S.SelectedOption>
      <S.Details>
        <Trans
          i18nKey="onboarding.feel_nervous.detailed"
          components={{ wrapper: <p /> }}
        />
      </S.Details>
      <Button onClick={handleNextClick}>{t('actions.continue')}</Button>
    </Container>
  )
}
